import React from "react";
import './ContenidoInicio.css'
import ContenedorDesplegable from "./ContenedorDesplegable";
import ContenedorMateriasAlumno from "./ContenedorMateriasAlumno";
import ContenedorConstanciasAlumnos from "./ContenedorConstanciasAlumnos";
import Noticia from "./Noticia";
import imagen_capacitacion from '../Assets/capacitacion.png'
import imagen_taller from '../Assets/taller.png'
import imagen_comunicado from '../Assets/comunicado.png'
import ContenedorLinksZoom from "./ContenedorLinksZoom";
import ContenidoNoticias from "./ContenidoNoticias"; // <--- IMPORTANTE


const ContenidoInicioAlumno = ({ redireccionC, redireccionA, a_titulo, a_contenido, b_titulo, b_contenido}) => {
    return (
        <div className="contenido-inicio">
            <div className="contenedor-izquierdo">
                <ContenedorDesplegable titulo={'Mis Constancias'} contenido={<ContenedorConstanciasAlumnos contenedorContancias={redireccionA} />} />
                <ContenedorDesplegable titulo={'Mis Cursos'} contenido={<ContenedorMateriasAlumno redireccionB={redireccionC} />} />
                <ContenedorDesplegable titulo={b_titulo} contenido={b_contenido} />
            </div>
            <div className="contenedor-derecho">
            <ContenedorDesplegable 
  titulo={'Noticias'}
  contenido={<ContenidoNoticias />}
/>
            </div>
        </div>
    )
}

export default ContenidoInicioAlumno